import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

interface RouteTooltipConfig {
  label: string;
  aiPrompt: string;
}

const routeTooltips: Record<string, RouteTooltipConfig> = {
  "/confronta-iphone": {
    label: "Ti serve un riassunto delle differenze?",
    aiPrompt: "Ciao! Sto confrontando dei modelli iPhone. Puoi farmi un riassunto delle differenze principali tra i modelli più recenti e aiutarmi a scegliere quello giusto per me?",
  },
  "/prodotti": {
    label: "Analisi convenienza: è il momento di comprare?",
    aiPrompt: "Certo! Che tipo di telefono stai cercando? Descrivi le tue esigenze, il tuo budget e per cosa lo userai. Ti aiuterò a trovare il prodotto migliore nel nostro catalogo!",
  },
  "/sfondi": {
    label: "Descrivi lo sfondo dei tuoi sogni",
    aiPrompt: "Perfetto! Dimmi come lo immagini. Che colori, soggetti, stile preferisci? Pensa a parole chiave come \"minimalista\", \"spaziale\", \"natura\" o \"futuristico\". Genererò lo sfondo perfetto per te!",
  },
};

interface AIContextTooltipProps {
  visible: boolean;
}

const AIContextTooltip = ({ visible }: AIContextTooltipProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);
  const config = routeTooltips[location.pathname];

  useEffect(() => {
    setDismissed(false);
  }, [location.pathname]);

  if (!config || !visible || dismissed) return null;

  const handleClick = () => {
    setDismissed(true);
    // Navigate to Tecly AI with the contextual prompt pre-filled
    navigate("/tecly-ai", { state: { prefillPrompt: config.aiPrompt, contextRoute: location.pathname } });
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 8, scale: 0.9 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 8, scale: 0.9 }}
        transition={{ duration: 0.2 }}
        onClick={handleClick}
        className="fixed bottom-[7.5rem] right-4 z-50 max-w-[200px] bg-card border border-border shadow-lg rounded-xl px-3 py-2 cursor-pointer"
      >
        <p className="text-xs text-foreground font-medium leading-snug">{config.label}</p>
        <div className="absolute -bottom-1.5 right-5 w-3 h-3 bg-card border-r border-b border-border rotate-45" />
      </motion.div>
    </AnimatePresence>
  );
};

export default AIContextTooltip;
